import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navigation from '../Navigation/navigation';
import PandaBuySignUpLink from '../PandaBuySignUpLink/PandaBuySignUpLink';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet';

const ProductDetails = () => {
  const { productId } = useParams();
  const productsState = useSelector((state) => state.products);
  const productData = productsState.products.find(product => product.productId === productId);

  if (!productsState.products.length) {
    console.log(productsState);
    return (
      <div>
        <Navigation />
        <h1 className='text-center'>Loading...</h1>
        <Footer />
      </div>
    );
  }

  if (!productData) {
    return (
    <div>
      <Navigation />
      <h1 className="text-center text-black">Product not found</h1>
      <Footer />
    </div>
    );
  }

  return (
    <div>
      <PandaBuySignUpLink />
      <Navigation />
      <Helmet>
        <title>{productData.itemName} - Superbuy</title>
        <meta name="description" content={`buy ${productData.itemName} now at Superbuy`} />
        <meta name="keywords" content={`${productData.itemName}, CNFans, Sugargoo, Superbuy`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.superbuyspreadsheet.net/products/${productData.searchName}/${productData.productId}`} />
      </Helmet>

      <div className='ProductDetailsDiv mt-12 flex max-lg:flex-col justify-evenly shadow-md max-lg:w-[450px] max-sm:w-full max-lg:ml-[23%] max-md:ml-[15%] max-sm:ml-0'>
        <div className='flex max-lg:justify-center'>
          <img src={`/images/${productData.productId}.webp`} alt={`${productData.itemName}`} className='cardlist max-sm:h-[335px] max-sm:w-full md:h-[450px] md:w-[450px]' />
        </div>

        <div className='ProductDetailsDiv flex flex-col lg:gap-y-[6.4rem] max-lg:gap-y-[2.4rem] max-sm:w-full max-sm:p-6'>
          <div className='pt-12 flex flex-col max-lg:items-center max-lg:justify-center'>

            <div className='flex flex-col gap-4'>
              <div>
                <p className='cardPriceTitle'>Product Title</p>
                <h2 className='cardTitle'>{productData.itemName}</h2>
              </div>

              <div>
                <p className='cardPriceTitle'>Product Price</p>
                <p className='cardTitle'>{productData.price}</p>
              </div>
            </div>

            {/* Affiliate Links Section */}
            <div className='flex flex-wrap gap-4 mt-8'>
              {productData.superBuyAffiliateLink && (
                <a href={productData.superBuyAffiliateLink} target='_blank' rel='noopener noreferrer' className='btn4 text-[16px]'>Buy at Superbuy</a>
              )}
              {productData.sugargooAffiliateLink && (
                <a href={productData.sugargooAffiliateLink} target='_blank' rel='noopener noreferrer' className='btn4 text-[16px]'>Buy at Sugargoo</a>
              )}
              {productData.cnfansAffiliateLink && (
                <a href={productData.cnfansAffiliateLink} target='_blank' rel='noopener noreferrer' className='btn4 text-[16px]'>Buy at CNFans</a>
              )}
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductDetails;
